import style from './menuGdacs.module.scss';
import React, {useEffect, useMemo, useState} from "react";
import {Scrollbars} from 'react-custom-scrollbars-2';
import {arrowRight, iconsSmile} from "../../util/assets";
import {ChartBar} from "./chart";
import moment from "moment-timezone";
import {outputNameHazard} from "../../util/util";
import {getLogs} from "../../thunk/device";
import {clearCurrentItem, setActiveMapData, setCurrentItem, setCurrentItemChangeActive} from "../../action/page";
import {getAddressMap} from "../../thunk/map";
import {setCurrentAlert} from "../../action/alert";
import {connect} from "react-redux";
import CloseIcon from '@mui/icons-material/Close';

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import TsunamiIcon from '@mui/icons-material/Tsunami';
import FloodIcon from '@mui/icons-material/Flood';
import CycloneIcon from '@mui/icons-material/Cyclone';
import VolcanoIcon from '@mui/icons-material/Volcano';
import AirIcon from '@mui/icons-material/Air';
import WhatshotIcon from '@mui/icons-material/Whatshot';

function MenuGdacs({
                  currentItem,
                  getLogs,
                  setCurrentItem,
                  getAddressMap,
                  page,
                  setCurrentAlert,
                  pointsBefore10Km,
                  map,
                  currentUser,
                  clearCurrentItem,
                  setCurrentItemChangeActive,
                  alerts
              }) {
    const handlerChangeStatus = (flug) => {
        let currentIndex = pointsBefore10Km.findIndex(item => item === currentItem._id); // next prev value
        let pointsBefore10KmLength = pointsBefore10Km.length;
        let id = "";
        let npi = 0;

        npi = flug === "n" ? currentIndex - 1 : currentIndex + 1;
        npi = npi < 0 ? pointsBefore10KmLength - 1 : npi > pointsBefore10KmLength - 1 ? 0 : npi;

        setCurrentItem({id: pointsBefore10Km[npi], status: "menuButton"});
    }
    const borderCenter = (distSize, coord) => {
        const dist = {big: 0.135, small: 0.045, less: 0.008} // big - 30km small - 10

        return [
            [
                coord.lat + dist[distSize],
                coord.lng - dist[distSize]
            ],
            [
                coord.lat - dist[distSize],
                coord.lng + dist[distSize]
            ]
        ];
    }
    useEffect(() => {
        // getLogs({id: currentItem._id});
        // if (currentItem.location && (page.state === "map" || page.state === "menuButton")) {
        if (currentItem.location && currentItem.location.length) {
            getAddressMap(currentItem.location.join(", "));
            setCurrentAlert({id: currentItem._id});
        }

        if (map && (page.state === "menuButton" || page.state === "pollutionAlerts") && window.google && currentItem.location) {
            let bounds = new window.google.maps.LatLngBounds();
            const coord = currentItem.location;
            const coordinates = borderCenter("less", {lat: coord[0], lng: coord[1]});

            bounds.extend(new window.google.maps.LatLng(coordinates[0][0], coordinates[0][1]));
            bounds.extend(new window.google.maps.LatLng(coordinates[1][0], coordinates[1][1]));
            map.fitBounds(bounds);
        }
    }, [
        currentItem
    ])

    // useMemo(() => {
    //     if (currentItem.active) {
    //         clearCurrentItem();
    //     }
    // }, [currentUser]);

    return (
        <div className={[style.menuRow, currentItem.active ? style.open : ""].join(" ")}>
            <div className={style.row}>
                {currentItem.properties && (
                    <Scrollbars style={{height: "calc(100vh - 134px)"}}>

                        <div className={style.container}>
                            <div
                                className={[style.baseInfo, style[currentItem.alertLevel]].join(" ")}>
                                <div className={style.baseInfoBlockH}>
                                    <div className={style.baseInfoBlock}>
                                        <div
                                            className={style.value}>{currentItem?.properties?.severitydata?.severity || "No data"}</div>
                                        <div className={style.name}>
                                            <span>{currentItem.properties.name}</span>
                                            {/* <span className={style.subName}>μg/m3</span> */}
                                        </div>
                                    </div>
                                    <div className={style.baseInfoBlock}>
                                        <div className={style.baseStatus}>
                                            {currentItem.alertLevel !== undefined && (
                                                <div className={style.icon}>
                                                    {currentItem.type === "EQ" && <MonitorHeartIcon className={style.iconImage}/>}
                                                    {currentItem.type === "TS" && <TsunamiIcon className={style.iconImage}/>}
                                                    {currentItem.type === "FL" && <FloodIcon className={style.iconImage}/>}
                                                    {currentItem.type === "TC" && <CycloneIcon className={style.iconImage}/>}
                                                    {currentItem.type === "VO" && <VolcanoIcon className={style.iconImage}/>}
                                                    {currentItem.type === "DR" && <AirIcon className={style.iconImage}/>}
                                                    {currentItem.type === "WF" && <WhatshotIcon className={style.iconImage}/>}
                                                    {/* <img
                                                        src={iconsSmile(currentItem.alertLevel || "")}
                                                        alt=""/> */}
                                                    {/*<IconsSmile*/}
                                                    {/*    index={currentItem.aqi}*/}
                                                    {/*    currentItem={currentItem}*/}
                                                    {/*/>*/}
                                                </div>
                                            )}
                                            <div className={style.text}>{outputNameHazard(currentItem.aqi)}</div>
                                        </div>
                                    </div>
                                </div>

                                {currentItem.properties.htmldescription && (
                                    <div className={style.description}>
                                        {currentItem.properties.severitydata.severitytext}
                                    </div>
                                ) || ""}
                            </div>
                            {/* {currentItem.iaqi && (
                                <SliderForMenu iaqi={currentItem.iaqi} aqi={currentItem.aqi}/>
                            )} */}
                            {/* {currentItem.aqi !== undefined && (
                                <ChartBar/>
                            )} */}

                            <div className={style.blockBarConteiner}>
                                {currentItem.properties.htmldescription}
                            </div>
                            



                            <div className={style.infoDevice}>
                                <div className={style.name}>
                                    <b>Sensor No:&nbsp;</b>
                                    <span>{currentItem.properties.glide}</span>
                                </div>
                                <div className={style.address}>
                                    <b>Address:&nbsp;</b>
                                    <span>{currentItem.properties.description}</span>
                                </div>
                                <div className={style.date}>
                                    <b>Date:&nbsp;</b>
                                    <span>{moment(currentItem.properties.fromdate).format('DD/MM/YYYY')}</span>
                                </div>
                                <div className={style.time}>
                                    <b>Time:&nbsp;</b>
                                    {/*&nbsp;*/}
                                    <span>{moment(currentItem.properties.fromdate).format('HH:mm:ss')}</span>
                                </div>
                                {currentItem.showSubInfo && (
                                    <>
                                        {currentItem.company && (
                                            <div className={style.address}>
                                                <b>Company Name:&nbsp;</b>
                                                <span>{currentItem.company.name}</span>
                                            </div>
                                        )}
                                        {/*{currentItem.title && (*/}
                                            <div className={style.address}>
                                                <b>Title:&nbsp;</b>
                                                <span>{currentItem.name}</span>
                                            </div>
                                        {/*)}*/}
                                    </>
                                )}
                            </div>

                            {pointsBefore10Km && pointsBefore10Km.length >= 2 && (
                                <div className={style.buttonsNavigation}>
                                    <div
                                        className={[style.button, style.prev].join(" ")}
                                        onClick={() => handlerChangeStatus("p")}
                                    >Prev. Sensor
                                    </div>
                                    <div
                                        className={[style.button, style.next].join(" ")}
                                        onClick={() => handlerChangeStatus("n")}
                                    >Next Sensor
                                    </div>
                                </div>
                            )}
                        </div>

                    </Scrollbars>
                )}

                {page.state === "mapNotFound" && (
                    <div className={style.mapNotFound}>
                        <b>Sorry :(</b>
                        <span>
                            There is no<br/>
                            air quality sensor <br/>
                            nearby yet.
                        </span>
                    </div>
                )}
            </div>
            <div className={style.close} onClick={() => setCurrentItem({active: false})}><CloseIcon /></div>
        </div>
    );
}

const mapStateToProps = state => ({
    page: state.page,
    currentItem: state.page.currentItem,
    currentUser: state.currentUser.user.filter,
    alerts: state.alerts,
    badges: state.page.badges,
    pointsBefore10Km: state.page.pointsBefore10Km
});

const mapDispatchToProps = dispatch => ({
    getAddressMap: data => dispatch(getAddressMap(data)),
    setActiveMapData: data => dispatch(setActiveMapData(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data)),
    setCurrentAlert: data => dispatch(setCurrentAlert(data)),
    clearCurrentItem: data => dispatch(clearCurrentItem(data)),
    setCurrentItemChangeActive: data => dispatch(setCurrentItemChangeActive(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuGdacs);
